import React, {useCallback, useEffect} from 'react';
import {Marker, TileLayer, useMap} from 'react-leaflet';

import {markerGreen} from '../../../../../services/map/mapMarkerCreatorService';

const TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
const TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

const MapContent = ({latitude, longitude, onMapClick, zoom, setZoom}) => {
    const map = useMap();

    const setView = useCallback(() => {
        if (latitude && longitude) {
            map.setView([latitude, longitude], zoom);
        }
    }, [latitude, longitude, zoom, map]);

    useEffect(() => {
        setView();
    }, [setView]);

    useEffect(() => {
        map.invalidateSize();
    }, [map]);

    const handleMapClick = async (event) => {
        setZoom(map.getZoom());

        await onMapClick(event);
    };

    useEffect(() => {
        map.on('click', handleMapClick);

        return () => {
            map.off('click', handleMapClick);
        };
    }, [map, handleMapClick]);

    return (
        <>
            <TileLayer attribution={TILE_ATTRIBUTION} url={TILE_URL} />
            {latitude && longitude && <Marker position={[latitude, longitude]} icon={markerGreen} />}
        </>
    );
};

export default MapContent;
